import {
  getSession,
  onAuthChange,
  signOut,
  type User,
} from '@/clients/supabase'
import type { MoodboardStore } from './moodboard'
import type { AlpineExtended } from '@/entrypoint-alpine'
import { sendCustomMoodboardEvent } from '@/utils/moodboard/event-helpers'

export type AuthStore = {
  user: User | null
  loading: boolean
  unsubscribe: (() => void) | null
  init(): Promise<void>
  isLoggedIn: boolean
  logout(): void
  destroy(): void
}

export const authStore = (Alpine: AlpineExtended): AuthStore => ({
  user: null,
  loading: false,
  unsubscribe: null,

  async init() {
    this.loading = true
    const { data, error } = await getSession()

    if (error) {
      this.user = null
    }

    this.unsubscribe = onAuthChange((event, session) => {
      if (event === 'INITIAL_SESSION') {
        this.user = session?.user ?? null
      } else if (event === 'SIGNED_IN') {
        this.user = session?.user ?? null
      } else if (event === 'SIGNED_OUT') {
        this.user = null
        ;(Alpine.store('moodboard') as MoodboardStore).clearBoards()
        this.unsubscribe?.()
        window.location.reload()
      } else if (event === 'PASSWORD_RECOVERY') {
        // handle password recovery event
      } else if (event === 'TOKEN_REFRESHED') {
        // handle token refreshed event
      } else if (event === 'USER_UPDATED') {
        // handle user updated event
      }
    })

    if (data?.session?.user) {
      this.user = data.session.user
      ;(Alpine.store('moodboard') as MoodboardStore).setLoggedInBoards()
    }

    this.loading = false
  },

  async logout() {
    this.loading = true
    try {
      const { error } = await signOut()
      if (error) throw error
      sendCustomMoodboardEvent('moodboard_logout_success')
    } catch (error) {
      console.error('Error during logout:', error)
    } finally {
      this.loading = false
    }
  },

  get isLoggedIn() {
    return !!this.user
  },

  destroy() {
    if (this.unsubscribe) {
      this.unsubscribe()
    }
  },
})
